"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TermsOfService() {
  const {
    ref: titleRef,
    isVisible: titleVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: narrativeRef,
    isVisible: narrativeVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: quoteRef,
    isVisible: quoteVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>();
  return <section data-section-id="3311" id="termsofservice" className="bg-background text-foreground py-24 md:py-40 lg:py-[200px] px-6 md:px-12 lg:px-20">
      <div className="max-w-[1400px] mx-auto">
        {}
        <div className="font-sans text-xs md:text-sm uppercase tracking-widest text-foreground mb-16 md:mb-24" style={{
        letterSpacing: "0.15em"
      }}>
          02 &mdash; POLICIES
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          {}
          <div ref={titleRef} className={`lg:col-span-4 transition-all duration-1000 ease-out ${titleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="lg:sticky lg:top-32">
              <h2 className="font-serif font-bold text-4xl md:text-5xl lg:text-[56px] leading-[1.05] text-foreground" style={{
              letterSpacing: "-0.03em"
            }}>
                Terms of
                <br />
                Service
              </h2>
              <div className="mt-6 flex items-center gap-3"><p className="font-sans italic text-sm md:text-base text-muted-foreground" data-ast-id="f:/src/pages/TermsOfService/sections/TermsOfService.tsx|sig:j1k2nq" data-ast-start="1689" data-ast-end="1828">God Father Company</p></div>
            </div>
          </div>

          {}
          <div className="lg:col-span-7 lg:col-start-6">
            <div ref={narrativeRef} className={`transition-all duration-1000 ease-out ${narrativeVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              {}
              <p className="font-sans text-[17px] md:text-[19px] text-foreground mb-8" style={{
              lineHeight: "1.75"
            }}>
                <span className="float-left font-serif font-bold text-[80px] md:text-[96px] leading-[0.85] mr-3 mt-1 text-primary" style={{
                letterSpacing: "-0.04em"
              }}>
                  W
                </span>
                elcome to God Father Company. By accessing our website or engaging our construction services in Austin, you agree to these terms. We are committed to transparency, quality craftsmanship, and professional integrity in every custom home build, renovation, and remodeling project we undertake. These terms govern your use of our digital platforms and our professional service agreements.
              </p>

              <p className="font-sans text-[17px] md:text-[19px] text-foreground mb-8" style={{
              lineHeight: "1.75"
            }}>Our team, operates with a focus on reliability and excellence. All estimates provided through our online portal are preliminary and subject to site assessment. We maintain strict standards for all residential projects, ensuring that every kitchen, bathroom, or home addition meets local building codes and our own high benchmarks for durability and aesthetic appeal.</p>

              <p className="font-sans text-[17px] md:text-[19px] text-foreground mb-8" style={{
              lineHeight: "1.75"
            }}>
                Intellectual property on this site, including project imagery and text, belongs to God Father Company. You may not reproduce our content without express written consent. We reserve the right to update these terms periodically to reflect changes in our operations or legal requirements. Your continued use of our services constitutes acceptance of any such modifications.
              </p>
            </div>

            {}
            <div ref={quoteRef} className={`my-16 md:my-20 py-16 md:py-20 transition-all duration-1000 ease-out ${quoteVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
              <div className="h-px w-full bg-primary" />
              <blockquote className="font-serif italic text-2xl md:text-3xl lg:text-[32px] text-center text-foreground py-12 md:py-16 px-4" style={{
              lineHeight: "1.4",
              letterSpacing: "-0.01em"
            }}>
                &ldquo;Building excellence with integrity.&rdquo;
              </blockquote>
              <div className="h-px w-full bg-primary" />
            </div>

            {}
            <div className={`transition-all duration-1000 ease-out ${quoteVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <p className="font-sans text-[17px] md:text-[19px] text-foreground mb-8" style={{
              lineHeight: "1.75"
            }}>
                Liability for construction projects is limited to the scope defined in our signed contracts. We prioritize safety and professional conduct on all job sites. If you have questions regarding our policies or wish to discuss a specific project, please contact our office directly. We value the trust our clients place in us to build their dream homes.
              </p>
            </div>

            {}
            <div ref={imageRef} className={`mt-16 md:mt-20 transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              
              
            </div>

            {}
            <div className={`mt-12 transition-all duration-1000 ease-out delay-200 ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <p className="font-sans text-[17px] md:text-[19px] text-foreground" style={{
              lineHeight: "1.75"
            }}>
                By choosing God Father Company, you are partnering with a team dedicated to quality and reliability. We strive to make every renovation or new build a seamless experience. Thank you for reviewing our terms and for considering us for your next residential project in the Austin area. We look forward to building something exceptional together.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}